// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"65c6084c","171":"4d99dd8b","309":"50763313","415":"78516ed4","453":"34a92a25","516":"3c75bd90","673":"30a012ba","880":"b8efb441"}[chunkId] + ".chunk.js";
};